export const enum enrollmentConstants  {
  
  // Get Enrollment List
  getEnrollmentRequest = "GET_ENROLLMENT_REQUEST",
  getEnrollmentSuccess = "GET_ENROLLMENT_SUCCESS",
  getEnrollmentFailure = "GET_ENROLLMENT_FAILURE",

  // Get Enrollment List with Params
  getEnrollmentParamsRequest = "GET_ENROLLMENT_PARAMS_REQUEST",
  getEnrollmentParamsSuccess = "GET_ENROLLMENT_PARAMS_SUCCESS",
  getEnrollmentParamsFailure = "GET_ENROLLMENT_PARAMS_FAILURE",

  // Create/Update Enrollment
  createEnrollmentRequest = "CREATE_ENROLLMENT_REQUEST",
  createEnrollmentSuccess = "CREATE_ENROLLMENT_SUCCESS",
  createEnrollmentFailure = "CREATE_ENROLLMENT_FAILURE",
  createEnrollmentReset = "CREATE_ENROLLMENT_RESET",

  // Delete Enrollment
  deleteEnrollmentRequest = "DELETE_ENROLLMENT_REQUEST",
  deleteEnrollmentSuccess = "DELETE_ENROLLMENT_SUCCESS",
  deleteEnrollmentFailure = "DELETE_ENROLLMENT_FAILURE",
  deleteEnrollmentReset = "DELETE_ENROLLMENT_RESET",

  // Get Enrollment View
  enrollmentViewRequest = "ENROLLMENT_VIEW_REQUEST",
  enrollmentViewSuccess = "ENROLLMENT_VIEW_SUCCESS",
  enrollmentViewFailure = "ENROLLMENT_VIEW_FAILURE",

  // Toggle Enrollment Status
  enrollmentToggleRequest = "ENROLLMENT_TOGGLE_REQUEST",
  enrollmentToggleSuccess = "ENROLLMENT_TOGGLE_SUCCESS",
  enrollmentToggleFailure = "ENROLLMENT_TOGGLE_FAILURE",

  // Export Enrollment
  exportEnrollmentRequest = "EXPORT_ENROLLMENT_REQUEST",
  exportEnrollmentSuccess = "EXPORT_ENROLLMENT_SUCCESS",
  exportEnrollmentFailure = "EXPORT_ENROLLMENT_FAILURE",

  // Assign Application
  assignApplicationRequest = "ASSIGN_APPLICATION_REQUEST",
  assignApplicationSuccess = "ASSIGN_APPLICATION_SUCCESS",
  assignApplicationFailure = "ASSIGN_APPLICATION_FAILURE",
  assignApplicationReset = "ASSIGN_APPLICATION_RESET",
};
